"use client";

import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import FeaturedNewsCard from "./cards/featured-news-card";
import { usePathname } from "next/navigation";
import { useCountryContext } from "@/providers/country-provider";
import { LATAM_COUNTRIES } from "@/lib/constants";

const FeaturedNews = () => {
	const featuredNewsCardData = [
		{
			id: "1",
			title:
				"Top Ten Proptech Companies That Are Revolutionizing the Real Estate Industry Across the United States in 2025",
			href: "https://www.proptechbuzz.com/blog/ten-proptech-companies-in-usa-real-estate",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/top-tech-prop.webp`,
		},
		{
			id: "2",
			title: "AgentMatchAI: Helping Property Agents Negotiate Confidently",
			href: "https://www.proptechbuzz.com/news/agentmatchai-property-agent-confidently",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/agent-match-ai.webp`,
		},
		{
			id: "3",
			title:
				"How Proptech-Enabled Broker Networks Are Transforming the Real Estate Market Landscape Across the United States in 2025",
			href: "https://www.proptechbuzz.com/blog/proptech-broker-networks-changing-market",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/future-real-estate.webp`,
		},
		{
			id: "4",
			title: "Will Austria's property market become more buyer-friendly now?",
			href: "https://www.proptechbuzz.com/news/austrias-property-market-become-more-buyer-friendly",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/austria-buyer-friendly.webp`,
			country: ["Austria"],
		},
		{
			id: "5",
			title: "Rents in Austria hit record highs as three states cross €20 per square metre",
			href: "https://www.proptechbuzz.com/news/rents-in-austria-hit-record-highs-as-three-states-cross-e20-per-square-metre",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/austria-rent-records.webp`,
			country: ["Austria"],
		},
		{
			id: "5",
			title: "The changes property buyers and renters can expect in Austria in 2025",
			href: "https://www.proptechbuzz.com/news/austria-housing-market-2025-changes",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/austria-property-2025.webp`,
			country: ["Austria"],
		},
		{
			id: "6",
			title: "Germany Eases Mortgage Capital Rules as Housing Market Stabilizes",
			href: "https://www.proptechbuzz.com/news/germany-mortgage-capital-buffer-cut",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/germany-mortgage-2025.webp`,
			country: ["Germany"],
		},
		{
			id: "7",
			title: "Germany Faces Bridge Renovation Delays, Auditors Urge Higher Funding",
			href: "https://www.proptechbuzz.com/news/germany-bridge-renovation-delays",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/germany-bridge-renovation-2025.webp`,
			country: ["Germany"],
		},
		{
			id: "8",
			title: "Germany's Residential Real Estate Investment Market Shows Signs of Steady Recovery",
			href: "https://www.proptechbuzz.com/news/germany-residential-real-estate-investment-q3",
			imageUrl: `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/featured-news/germany-real-estate-recovery-2025.webp`,
			country: ["Germany"],
		},
		{
			id: "9",
			title: "Top Halal Investment Options In Bangladesh For 2025",
			href: "https://www.proptechbuzz.com/news/halal-investment-options-bangladesh",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2Fca962371-5722-41a7-ac51-5ede1375650f&w=640&q=75",
			country: ["Bangladesh"],
		},
		{
			id: "10",
			title:
				"Bproperty and Rupayan Group launch joint venture to transform Bangladesh's real estate sector",
			href: "https://www.proptechbuzz.com/news/bproperty-rupayan-strategic-partnership-bangladesh-real-estate",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2Fb7acd07e-ca01-4dfd-8d1b-86be0d13b8f0&w=640&q=75",
			country: ["Bangladesh"],
		},
		{
			id: "11",
			title: "Bangladesh Construction Industry Databook 2025",
			href: "https://www.proptechbuzz.com/news/bangladesh-construction-market-forecast",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2F5ed140cb-279e-4a26-8b8f-ea1dc07ccee1&w=640&q=75",
			country: ["Bangladesh"],
		},
		{
			id: "12",
			title: "Latin America Startup Sector Sees 26% Investment Jump",
			href: "https://www.proptechbuzz.com/news/latin-america-startup-investment-2024-growth",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2Fc34809a5-6597-4183-ab00-23366a431fca&w=640&q=75",
			country: LATAM_COUNTRIES,
		},
		{
			id: "13",
			title: "Latin America's Construction Market Forecasts Modest Growth to USD 514.29 Billion by 2030",
			href: "https://www.proptechbuzz.com/news/latin-america-construction-market-growth",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2Fa8eeb87d-78fd-46f7-b64d-ea77e0fe49c5&w=640&q=75",
			country: LATAM_COUNTRIES,
		},
		{
			id: "14",
			title: "Emerging Trends in Latin America's Real Estate Market",
			href: "https://www.proptechbuzz.com/news/latin-america-real-estate-trends",
			imageUrl:
				"https://www.proptechbuzz.com/_next/image?url=https%3A%2F%2Fcms.proptechbuzz.com%2Fassets%2F2aabbfc1-2348-474d-b608-56f6975d1dea&w=640&q=75",
			country: LATAM_COUNTRIES,
		},
	];

	const pathname = usePathname();
	const { name, country, portals } = useCountryContext();
	const isCountryPortalPage = pathname === portals.current.href;
	let featuredNews = featuredNewsCardData;

	if (isCountryPortalPage && Array.isArray(country)) {
		featuredNews = featuredNewsCardData.filter((news) =>
			news.country?.some((c) => country.includes(c))
		);
	}

	return (
		<section>
			<div className="mb-7 mt-7 flex items-center justify-between gap-x-4">
				<h2 className="text-xl font-bold text-gray-900 sm:whitespace-nowrap md:text-2xl">
					{isCountryPortalPage ? name : "Global"} Proptech Stories
				</h2>

				<div className="hidden h-[0.5px] w-full bg-gray-200 sm:block" />

				<Link
					href="/news"
					className="flex w-fit items-center justify-start gap-x-2 text-sm font-medium text-brand-primary"
				>
					<span className="whitespace-nowrap">See more news</span>
					<span>
						<ArrowRightIcon className="h-4 w-4" />
					</span>
				</Link>
			</div>

			<div className="mx-auto grid max-w-2xl grid-cols-1 gap-6 lg:mx-0 lg:max-w-none lg:grid-cols-3">
				{featuredNews.slice(0, 3).map((news) => (
					<FeaturedNewsCard key={news.id} {...news} />
				))}
			</div>
		</section>
	);
};

export default FeaturedNews;
